export default "__VITE_ASSET__53382ea3__"